import React, { useState, useEffect } from "react";
import { Col, Row, Card, Button, Table, Spinner, Form } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { client } from "../../api/client";

export default () => {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [defaultPrice, setDefaultPrice] = useState(1000);
  
  // Form states
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");
  const [valueFree, setValueFree] = useState(""); // free_mariage_count

  const fetchRules = async () => {
    setLoading(true);
    try {
      const [rulesData, grilleData] = await Promise.all([
        client("free-mariage-rules/"),
        client("grille-gains/?target_level=TENANT").catch(() => null)
      ]);

      const rulesList = Array.isArray(rulesData) ? rulesData : (rulesData?.results || []);
      setRules(rulesList);

      const g = Array.isArray(grilleData) ? grilleData[0] : (grilleData?.results?.[0] || grilleData);
      if (g && (g.mariage_gratuit_multiplier || g.mariage_multiplier)) {
        setDefaultPrice(parseFloat(g.mariage_gratuit_multiplier || g.mariage_multiplier || 1000));
      }
    } catch (err) {
      console.error("Failed to fetch free marriage rules:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRules();
  }, []);

  const handleAddRule = async (e) => {
    e.preventDefault();
    if (!minAmount || !maxAmount || !valueFree) {
      alert("Veuillez remplir tous les champs.");
      return;
    }

    const minVal = parseFloat(minAmount);
    const maxVal = parseFloat(maxAmount);
    const freeCount = parseInt(valueFree) || 1;

    if (isNaN(minVal) || isNaN(maxVal) || isNaN(freeCount) || freeCount <= 0) {
      alert("Veuillez entrer des valeurs numériques valides.");
      return;
    }

    if (minVal > maxVal) {
      alert("Le montant minimum ('A pati de') ne peut pas être supérieur au montant maximum ('A tel pri').");
      return;
    }

    // Payout rate per winning free mariage = defaultPrice defined in Primes
    const body = {
      min_ticket_amount: minVal,
      max_ticket_amount: maxVal,
      free_mariage_count: freeCount,
      fixed_payout: defaultPrice,
      target_level: "GENERAL",
      is_active: true
    };

    try {
      await client("free-mariage-rules/", {
        method: "POST",
        body
      });
      setMinAmount("");
      setMaxAmount("");
      setValueFree("");
      fetchRules();
    } catch (err) {
      console.error("Failed to add free marriage rule:", err);
      alert("Erreur lors de l'ajout: " + (err?.detail || err?.message || JSON.stringify(err)));
    }
  };

  const handleDeleteRule = async (id) => {
    if (!window.confirm("Voulez-vous vraiment supprimer cette règle ?")) return;

    try {
      await client(`free-mariage-rules/${id}/`, { method: "DELETE" });
      fetchRules();
    } catch (err) {
      console.error("Failed to delete free marriage rule:", err);
      alert("Erreur lors de la suppression.");
    }
  };

  return (
    <div style={{ padding: '16px 0' }}>
      <Card className="border-0 shadow-sm" style={{ borderRadius: '8px' }}>
        <Card.Header className="bg-white border-0 pt-4 pb-0">
          <h4 style={{ fontWeight: 'bold', color: '#333', margin: 0 }}>Configuration mariage gratuit</h4>
        </Card.Header>

        <Card.Body>
          <style>{`
            .custom-input::placeholder {
              font-size: 0.78rem !important;
              color: #999999 !important;
              opacity: 1 !important;
            }
            .custom-input {
              font-size: 0.85rem !important;
              color: #111111 !important;
            }
          `}</style>
          <Form onSubmit={handleAddRule} className="mb-4">
            <Row className="mb-3">
              {/* Field 1: A pati de */}
              <Col xs={12} md={4} className="mb-3 mb-md-0">
                <Form.Label className="small fw-bold mb-1" style={{ color: '#111' }}>A pati de (kantite kòb)</Form.Label>
                <div className="position-relative d-flex align-items-center">
                  <Form.Control 
                    type="text"
                    placeholder="Ex: 50"
                    className="custom-input"
                    style={{ borderColor: '#28A745', borderRadius: '4px', paddingRight: '36px' }}
                    value={minAmount}
                    onChange={(e) => setMinAmount(e.target.value.replace(/[^0-9]/g, ''))}
                  />
                  <FontAwesomeIcon 
                    icon={faCheck} 
                    className="position-absolute" 
                    style={{ right: '12px', color: minAmount ? '#28A745' : '#CCCCCC', transition: 'color 0.2s ease' }} 
                  />
                </div>
              </Col>

              {/* Field 2: A tel pri */}
              <Col xs={12} md={4} className="mb-3 mb-md-0">
                <Form.Label className="small fw-bold mb-1" style={{ color: '#111' }}>A tel pri (kantite kòb)</Form.Label>
                <div className="position-relative d-flex align-items-center">
                  <Form.Control 
                    type="text"
                    placeholder="Ex: 100"
                    className="custom-input"
                    style={{ borderColor: '#28A745', borderRadius: '4px', paddingRight: '36px' }}
                    value={maxAmount}
                    onChange={(e) => setMaxAmount(e.target.value.replace(/[^0-9]/g, ''))}
                  />
                  <FontAwesomeIcon 
                    icon={faCheck} 
                    className="position-absolute" 
                    style={{ right: '12px', color: maxAmount ? '#28A745' : '#CCCCCC', transition: 'color 0.2s ease' }} 
                  />
                </div>
              </Col>

              {/* Field 3: Vale mariaj gratis */}
              <Col xs={12} md={4}>
                <Form.Label className="small fw-bold mb-1" style={{ color: '#111' }}>Vale mariaj gratis</Form.Label>
                <div className="position-relative d-flex align-items-center">
                  <Form.Control 
                    type="text"
                    placeholder="Ex: 5"
                    className="custom-input"
                    style={{ borderColor: '#28A745', borderRadius: '4px', paddingRight: '36px' }}
                    value={valueFree}
                    onChange={(e) => setValueFree(e.target.value.replace(/[^0-9]/g, ''))}
                  />
                  <FontAwesomeIcon 
                    icon={faCheck} 
                    className="position-absolute" 
                    style={{ right: '12px', color: valueFree ? '#28A745' : '#CCCCCC', transition: 'color 0.2s ease' }} 
                  />
                </div>
              </Col>
            </Row>

            {/* Ajouter Button */}
            <Button
              type="submit"
              style={{
                backgroundColor: '#007BFF',
                borderColor: '#007BFF',
                color: '#FFF',
                fontWeight: '600',
                padding: '10px 0',
                borderRadius: '4px',
                width: '100%',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              Ajouter
            </Button>
          </Form>

          {/* List of rules */}
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="primary" />
              <div className="text-muted small mt-2">Chargement des configurations...</div>
            </div>
          ) : (
            <div className="table-responsive">
              <Table bordered hover className="align-items-center mb-0" style={{ borderCollapse: 'collapse', borderColor: '#EAEAEA' }}>
                <tbody>
                  {rules.length > 0 ? (
                    rules.map((rule, idx) => {
                      const count = rule.free_mariage_count || 1;
                      const payoutGoud = parseFloat(rule.fixed_payout || defaultPrice).toFixed(0);
                      return (
                        <tr key={rule.id || idx}>
                          <td style={{ padding: '12px 16px', fontSize: '0.9rem', color: '#333' }}>
                            Apati de <strong>{parseFloat(rule.min_ticket_amount).toFixed(0)} GDS</strong>
                          </td>
                          <td style={{ padding: '12px 16px', fontSize: '0.9rem', color: '#333' }}>
                            A tel pri <strong>{parseFloat(rule.max_ticket_amount).toFixed(0)} GDS</strong>
                          </td>
                          <td style={{ padding: '12px 16px', fontSize: '0.9rem', color: '#333' }}>
                            <strong>{count}</strong> mariaj gratis (peye a : <strong>{payoutGoud} goud</strong>)
                          </td>
                          <td className="text-center" style={{ padding: '12px 16px', width: '100px' }}>
                            <Button
                              variant="link"
                              className="text-danger p-0 fw-bold"
                              style={{ textDecoration: 'none', fontSize: '0.9rem' }}
                              onClick={() => handleDeleteRule(rule.id)}
                            >
                              Efase
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-4 text-muted small">
                        Aucune configuration de mariage gratuit enregistrée.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};
